import { 
  faPlaystation, 
  faXbox, 
  faWindows, 
  faApple, 
  faLinux, 
  faSteam,
  faAndroid
} from '@fortawesome/free-brands-svg-icons';
import { 
  faGamepad, 
  faMobileScreen, 
  faGlobe,
  faDesktop
} from '@fortawesome/free-solid-svg-icons';

export const platformIcons = {
  'PlayStation': faPlaystation,
  'PlayStation 2': faPlaystation,
  'PlayStation 3': faPlaystation,
  'PlayStation 4': faPlaystation,
  'PlayStation 5': faPlaystation,
  'PS Vita': faMobileScreen,
  'PSP': faMobileScreen,
  'Xbox': faXbox,
  'Xbox 360': faXbox,
  'Xbox One': faXbox,
  'Xbox Series S/X': faXbox,
  'PC': faWindows,
  'Steam': faSteam,
  'macOS': faApple,
  'Classic Macintosh': faApple,
  'Apple II': faApple,
  'Linux': faLinux,
  'Nintendo Switch': faGamepad,
  'Nintendo 3DS': faGamepad,
  'Nintendo DS': faGamepad,
  'Nintendo DSi': faGamepad,
  'Nintendo 64': faGamepad,
  'Nintendo GameCube': faGamepad,
  'Game Boy': faGamepad,
  'Game Boy Advance': faGamepad,
  'SNES': faGamepad,
  'NES': faGamepad,
  'Wii': faGamepad,
  'Wii U': faGamepad,
  'Android': faAndroid,
  'iOS': faMobileScreen,
  'Web': faGlobe,
  'Default': faDesktop
}; 
